<script setup>
defineProps({
    src: {type: String, required: true},
})
</script>

<template>
    <span
        class="inline-block shrink-0"
        :style="{
            WebkitMaskImage: `url(${src})`,
            maskImage: `url(${src})`,
            WebkitMaskSize: 'contain',
            maskSize: 'contain',
            WebkitMaskRepeat: 'no-repeat',
            maskRepeat: 'no-repeat',
            WebkitMaskPosition: 'center',
            maskPosition: 'center',
        }"
    />
</template>
